module.exports = __webpack_public_path__ + "static/media/land-elife-banner-img-mobile.03df7bf3.jpg";